import { render, staticRenderFns } from "./club-payments.vue?vue&type=template&id=7ffedde1&scoped=true&"
import script from "./club-payments.vue?vue&type=script&lang=ts&"
export * from "./club-payments.vue?vue&type=script&lang=ts&"
import style0 from "./club-payments.vue?vue&type=style&index=0&id=7ffedde1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffedde1",
  null
  
)

export default component.exports